module.exports = __webpack_public_path__ + "img/icon_sm_tcyw.776b717e.png";